import { library } from '@fortawesome/fontawesome-svg-core'
import * as solid from './v5/solid'
import * as regular from './v5/regular'
import * as light from './v5/light'
import * as duotone from './v5/duotone'
import * as brands from './v5/brands'
import * as custom from './custom'
import * as avatarsUsers from './v5/avatars/users'
// Deep per-icon imports, not the package barrel. The barrel is ~363 KB parsed and
// lands whole in the entry bundle; these three modules are a few hundred bytes each.
import { faGlobeAmericas } from '@fortawesome/pro-regular-svg-icons/faGlobeAmericas'
import { faSolarSystem } from '@fortawesome/pro-regular-svg-icons/faSolarSystem'
import { faPlanetRinged } from '@fortawesome/pro-regular-svg-icons/faPlanetRinged'

library.add(solid, regular, light, duotone, brands, custom, avatarsUsers, faGlobeAmericas, faSolarSystem, faPlanetRinged)
